exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 767px) {\n  [class*=\"col\"] {\n    min-height: 100vh;\n    background: #fff;\n  }\n}\n.left-col {\n  background: #fffaf2;\n  color: #f7a700;\n}\n\na, a:hover, a:focus {\n  color: #f7a700;\n}\n\n.content {\n  width: 50%;\n  margin: auto;\n}\n\n@media (max-width: 767px) {\n  .content {\n    width: 80%;\n  }\n  .vertical-center {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    min-height: 50vh;\n  }\n  [class*=\"col\"] {\n    min-height: 50vh;\n    \n  }\n}\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/app/work/deepcrawl/deepcrawl.component.css
// module id = ../../../../../src/app/work/deepcrawl/deepcrawl.component.css
// module chunks = main